const { serialize } = require("../../utils");

export default {
  namespaced: true,
  state: {
    path: "aljabr/salary-ranks",
  },
  actions: {
    get({ dispatch, state, rootState }, options = {}) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}?${serialize(options)}`,
            method: "GET",
            data: {},
          },
          { root: true }
        );
      }
    },
    
    add({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/add`,
            method: "POST",
            data,
          },
          { root: true }
        );
      }
    },
    
    update({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/update`,
            method: "POST",
            data,
          },
          { root: true }
        );
      }
    },
    
    delete({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/delete`,
            method: "POST",
            data,
          },
          { root: true }
        );
      }
    },
  },
}; 